<template>
  <div class="">
    <modal
      v-if="modalData.show"
      @close="closeModal"
      :clickOutsideToClose="false"
    >
      <template slot="header">
        <h3 class="modal-title">
          {{ $t("user.locked_setting") }}
        </h3>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeModal"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="md-layout lock-time-box">
              <label
                class="md-layout-item md-size-35 md-small-size-100 md-form-label place-self-center required-field"
                >{{ $t("user.startTime") }}
              </label>
              <div
                class="md-layout-item md-size-65 md-small-size-100 datetime-input"
              >
                <ValidationProvider
                  :name="$t('user.startTime')"
                  rules="required"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon style="margin: 0;">today</md-icon>
                    <vue-datetime
                      type="datetime"
                      v-model="params.start_time"
                      :min-datetime="timeNow"
                      :disabled="modalData.end_time !== null"
                      zone="Asia/Ho_Chi_Minh"
                      input-class="vue-datetime-input"
                      :phrases="{
                        ok: $t('common.continue'),
                        cancel: $t('common.exit')
                      }"
                      class="theme-purple"
                      auto
                    ></vue-datetime>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div class="md-layout lock-time-box">
              <label
                class="md-layout-item md-size-35 md-small-size-100 md-form-label place-self-center required-field"
                >{{ $t("user.endTime") }}
              </label>
              <div
                class="md-layout-item md-size-65 md-small-size-100 datetime-input"
              >
                <ValidationProvider
                  :name="$t('user.endTime')"
                  rules="required"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-icon style="margin: 0;">today</md-icon>
                    <vue-datetime
                      type="datetime"
                      v-model="params.end_time"
                      :min-datetime="timeNow"
                      zone="Asia/Ho_Chi_Minh"
                      input-class="vue-datetime-input"
                      :phrases="{
                        ok: $t('common.continue'),
                        cancel: $t('common.exit')
                      }"
                      class="theme-purple"
                      auto
                    ></vue-datetime>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <div class="md-layout">
              <label
                class="md-layout-item md-size-35 md-small-size-100 md-form-label place-self-center required-field"
                >{{ $t("user.reason") }}
              </label>
              <div class="md-layout-item md-size-65 md-small-size-100">
                <ValidationProvider
                  :name="$t('user.reason')"
                  rules="required|max:200"
                  v-slot="{ passed, failed, errors }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-textarea v-model="params.reason"></md-textarea>
                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
            </div>
            <md-card-actions class="text-center">
              <md-button
                class="md-warning"
                style="margin-right: 10px;"
                @click="unlockUser(item)"
                v-if="
                  modalData.end_time &&
                    modalData.end_time > displayTime(new Date())
                "
                >{{ $t("user.unlock") }}
              </md-button>
              <md-button
                type="submit"
                class="md-success"
                style="margin-right: 10px;"
                >{{ $t("common.update") }}
              </md-button>
              <md-button class="md-danger" @click="closeModal">Close</md-button>
            </md-card-actions>
          </form>
        </ValidationObserver>
      </template>
    </modal>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import { Modal } from "@/components";
import moment from "moment";

export default {
  name: "UserLockModal",
  components: {
    Modal,
    SlideYDownTransition
  },
  data() {
    return {
      params: {
        start_time: this.displayTime(new Date()),
        end_time: this.displayTime(new Date()),
        reason: ""
      },
      timeNow: moment(new Date(), "YYYY-MM-DD HH:mm:ss").toISOString()
    };
  },
  props: ["modalData", "item"],
  methods: {
    submit() {
      let startTime = this.displayTime(this.params.start_time);
      let endTime = this.displayTime(this.params.end_time);
      if (startTime > endTime) {
        this.$notify({
          title: this.$t("common.failure"),
          text: this.$t("user.invalid_range_time"),
          type: "error"
        });
      } else if (
        !this.modalData.end_time &&
        (startTime < this.displayTime(new Date()) ||
          endTime < this.displayTime(new Date()))
      ) {
        this.$notify({
          title: this.$t("common.failure"),
          text: this.$t("user.not_in_past"),
          type: "error"
        });
      } else if (
        this.modalData.end_time &&
        endTime < this.displayTime(new Date())
      ) {
        this.$notify({
          title: this.$t("common.failure"),
          text: this.$t("user.send_time_not_in_past"),
          type: "error"
        });
      } else {
        this.lockUser(this.item);
      }
    },
    closeModal() {
      this.resetParams();
      this.$emit("closeModal");
    },
    lockUser(item) {
      let params = {
        start_time: this.formatTime(this.params.start_time),
        end_time: this.formatTime(this.params.end_time),
        reason: this.params.reason
      };
      this.$emit("lockUser", item, params);
      this.closeModal();
    },
    unlockUser(item) {
      this.$emit("unlockUser", item);
      this.closeModal();
    },
    displayTime(value) {
      if (!value) return null;
      return moment(new Date(value), "YYYY-MM-DD HH:mm:ss").toISOString();
    },
    formatTime(value) {
      if (!value) return null;
      return moment(new Date(value), "YYYY-MM-DD HH:mm:ss").format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    resetParams() {
      this.params.start_time = this.displayTime(new Date());
      this.params.end_time = this.displayTime(new Date());
      this.params.reason = "";
    }
  },
  watch: {
    modalData: {
      handler(newVal) {
        this.params.start_time = this.displayTime(
          newVal.start_time || new Date()
        );
        this.params.end_time = this.displayTime(newVal.end_time || new Date());
        this.params.reason = newVal.reason;
      },
      deep: true
    }
  },
  mounted() {
    this.params.start_time = this.displayTime(
      this.modalData.start_time || new Date()
    );
    this.params.end_time = this.displayTime(
      this.modalData.end_time || new Date()
    );
    this.params.reason = this.modalData.reason;
  }
};
</script>

<style lang="scss" scoped>
.datetime-input {
  display: inline-flex;
}
.lock-time-box {
  margin: 15px 0;
}
label {
  text-align: left;
  padding: 0;
}
</style>
